import RewardsPreview from './RewardsPreview';

export default RewardsPreview;
